<template>
  <div class="error-page" :style="{ paddingTop: `${paddingTop}px` }">
    <van-empty :description="message.text" :image="message.image">
      <van-button
        type="primary"
        size="middle"
        @click="reload"
        v-if="['network', 'server'].includes(errorType)"
        class="bottom-button"
        round
      >
        {{ errorType === 'network' ? '重新加载' : '重试' }}
      </van-button>
    </van-empty>
  </div>
</template>
<script>
// eslint-disable-next-line
const errorServer = require('@/assets/images/placeholder/error-server.png');
// eslint-disable-next-line
const errorNet = require('@/assets/images/placeholder/off-line.png');
// eslint-disable-next-line
const blankData = require('@/assets/images/placeholder/no-data.png');

export default {
  props: {
    errorType: {
      type: String,
      default: 'network',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    paddingTop: {
      type: Number,
      default: 100,
    },
  },
  computed: {
    message() {
      if (this.errorType === 'server') {
        return {
          text: this.errorMessage || '服务器出错，请重试',
          image: errorServer,
        };
      }
      if (this.errorType === 'network') {
        return {
          text: this.errorMessage || '没有网络，请重新连接',
          image: errorNet,
        };
      }
      if (this.errorType === 'empty') {
        return {
          text: this.errorMessage || '暂无数据',
          image: blankData,
        };
      }
      return {
        text: this.errorMessage || '页面出错',
        image: errorServer,
      };
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.error-page {
  background: #f5f5f5;
  height: 100%;
  .bottom-button {
    min-width: 112px;
  }
}
</style>
